<section class="signature-protection" data-testid="signature-protection-section">
  <div class="signature-protection__title-row">
    <puro-typography
      class="signature-protection__title"
      variant="h5"
      component="h2"
      color="primary"
    >
      {{ messagingKeyPrefix() + '.title' | translate }}
    </puro-typography>
    <span class="visually-hidden" id="signature-protection-tooltip-desc">{{
      signatureTooltipPlainText()
    }}</span>
    <puro-tooltip
      #signatureTooltip
      [content]="'createShipment.serviceStep.signatureProtection.tooltip' | translate"
      (mouseenter)="prepareSignatureTooltipHtml()"
    >
      <button
        type="button"
        class="signature-protection__tooltip-trigger"
        data-testid="signature-protection-tooltip"
        [attr.aria-label]="'createShipment.serviceStep.signatureProtection.tooltipAria' | translate"
        aria-describedby="signature-protection-tooltip-desc"
        (click)="$event.preventDefault(); $event.stopPropagation()"
        (focus)="showSignatureTooltip()"
        (blur)="signatureTooltip.hide()"
      >
        <puro-icon name="info-circle-tooltip" size="sm" aria-hidden="true" />
      </button>
    </puro-tooltip>
  </div>

  <div class="signature-protection__body" [formGroup]="form()">
    <puro-typography class="signature-protection__description" component="p" variant="body2">
      <span>{{ messagingKeyPrefix() + '.descriptionBefore' | translate }}</span>
      <strong>{{ messagingKeyPrefix() + '.descriptionEmphasis' | translate }}</strong>
      <span>{{ messagingKeyPrefix() + '.descriptionAfter' | translate }}</span>
    </puro-typography>

    <puro-select
      class="signature-protection__select"
      data-testid="signature-requirement-select"
      [label]="'createShipment.serviceStep.signatureProtection.selectLabel' | translate"
      labelPosition="floating"
      [fullWidth]="true"
      [options]="requirementOptions()"
      [formControl]="form().controls.requirement"
    />
  </div>
</section>
